import React, { useState } from 'react';


export default function RedQuickPanel(props: any) {
    const [open, setOpen] = useState(false);
    function footer() {
        return props.footer ? props.footer() : [];
    }
    function stretch() {
        return props.stretch ? { height: '100%' } : {}
    }
    function bodyBackgroundColor() {
        return props.bodyBackgroundColor ? { backgroundColor: props.bodyBackgroundColor } : {};
    }
    function cardStyle() {
        return props.cardStyle || {};
    }
    function bodyStyle() {
        return {
            ...bodyBackgroundColor()
        }
    }
    function sidePanel() {
        return (
            <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row'
            }}>
                <div style={{
                    minWidth: 250
                }}>{props.sidepanel}</div>
                <div style={{
                    flex: 1
                }}>{props.children}</div>
            </div>
        )
    }
    return (
        <div className={`card direct-chat direct-chat-warning box-header ${props.cls || ''}`} style={{
            display: 'flex',
            paddingTop: 1,
            paddingBottom: 1,
            overflow: 'hidden',
            ...cardStyle(),
            ...stretch()
        }}>
            <div className="card-header drag-me-header">
                <h3 className="card-title">{props.title}</h3>
                <div className="card-tools">
                    {props.buttons}
                </div>
            </div>
            <div className="card-body" onDragOver={(ev) => {
                ev.preventDefault();
                ev.dataTransfer.dropEffect = "copy";
                if (props.onBodyDragOver) {
                    props.onBodyDragOver(ev);
                }
            }}
                onDrop={(ev) => {
                    if (props.onBodyDrop) {
                        props.onBodyDrop(ev);
                    }
                }} style={{ ...bodyStyle() }}>
                {!!props.sidepanel ? sidePanel() : props.children}
            </div>
            <div className="card-footer">
                {footer()}
            </div>
        </div >
    )
}